import type { ReactNode } from 'react'

import cx from 'classnames'

import styles from '../patient-search/patient-search.module.css'

interface CardProps {
  children: ReactNode
  border?: 'red' | 'blue'
}

export function Card ({ children, border }: CardProps): JSX.Element {
  return (
    <div
      className={cx(
        styles.patientWrapper,
        'relative bg-white py-4 pl-4 pr-6 mx-2 rounded-md shadow-sm'
      )}
    >
      {children}
      {border && (
        <div className={cx('h-full rounded-l-md w-1.5 left-0 absolute top-0', border === 'blue' ? 'bg-[#2F7DE1]' : 'bg-[#F2545A]')} />
      )}
    </div>
  )
}

interface CardsProps {
  children: ReactNode
}

export function Cards ({ children }: CardsProps): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
        marginTop: '14px',
        borderRadius: '16px'
      }}
    >
      {children}
    </div>
  )
}
